export default class SocialMediaService {
  constructor ({ linksToShare }) {
    this._linksToShare = linksToShare
  }

  socialMedia () {
    const { VUE_APP: { roomDisplay: { socialMedia = [] } = {} } = {} } = global
    return socialMedia.map(socialMediaName => ({
      name: socialMediaName,
      link: this._linksToShare[socialMediaName.toLowerCase()]
    }))
  }
}
